import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { message } from 'antd';

export interface ApiErrorResponse {
  data?: {
    message?: string;
    errors?: Record<string, string>;
    default?: string;
  };
  message?: string;
}

export const getApiErrorMessage = (
  err: unknown,
  fallbackMessage?: string
): string => {
  const apiError = err as ApiErrorResponse;
  return (
    apiError?.data?.errors?.default ||
    (apiError?.data?.errors &&
      typeof apiError.data.errors === 'object' &&
      Object.values(apiError.data.errors)[0]) ||
    apiError?.data?.message ||
    apiError?.data?.default ||
    apiError?.message ||
    fallbackMessage ||
    ''
  );
};

export const useHandleApiError = () => {
  const { t } = useTranslation();

  const handleApiError = useCallback(
    (err: unknown, fallbackKey = 'somethingWentWrong'): string => {
      const errorMessage =
        getApiErrorMessage(err, t(fallbackKey)) || t(fallbackKey);
      message.error(errorMessage);
      return errorMessage;
    },
    [t]
  );

  return { handleApiError };
};

export default useHandleApiError;

